import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import Icon from '../../../Shared/Icon/Icon'
import Tooltip from '../../../Shared/Tooltip'

import SoftwareListContainer from './SoftwareListContainer'

function JobInfoRow({
  type,
  deadline = null,
  applicationCount = 0,
  isResellable,
  isFeatured = false,
  software,
  status,
  isApplicationCountVisible,
  isViewerDesigner = false,
  skills,
  skillsFilterOptions = null,
  softwareFilterOptions,
  withLinks = false,
  isPublicListing,
}) {
  const tooltipText = isViewerDesigner
    ? 'Client renounced exclusive rights to content created with this 3D Project, furthermore the designer is allowed '
    + 'to retain the Intellectual property rights and publish Project results on the marketplace.'
    : 'You have renounced exclusive rights to content created with this 3D Project, furthermore allowed designer to '
    + 'retain the Intellectual property rights and publish Project results on the CGTrader marketplace.'

  return (
    <Fragment>
      <ul className="job-list-item__tags">
        {isFeatured && (
          <li className="tag tag--private">
            <Icon type={['far', 'trophy']} className="tag-icon" />
            Featured
          </li>
        )}
        {!isPublicListing && type === 'public' ? (
          <li className="tag tag--public">
            <Icon type={['fas', 'users']} className="tag-icon" />
            Public
          </li>
        ) : !isPublicListing && type !== 'public' && (
          <li className="tag tag--private">
            <Icon type={['fas', 'lock']} className="tag-icon" />
            Private
          </li>
        )}
        {['unapproved', 'approved', 'started'].includes(status) && (
          <li className="tag tag--info">
            {deadline ? (
              <Fragment>
                {moment().isBefore(moment(deadline, 'X')) ? 'Expires ' : status === 'started' ? 'Deadline passed ' : 'Expired '}
                {moment(deadline, 'X').fromNow()}
              </Fragment>
            ) : (
              <Fragment>No fixed deadline</Fragment>
            )}
          </li>
        )}
        {isApplicationCountVisible && (
          <li className="tag tag--info">
            {applicationCount} {applicationCount !== 1 ? 'Applicants' : 'Applicant'}
          </li>
        )}
        {isResellable && (
          <li className="tag tag--info">
            <Tooltip id="resell-tooltip" content={tooltipText} className="u-block" randomiseID>
              Resell
            </Tooltip>
          </li>
        )}
        {skills && skills.length > 0 && (
          <li className="tag tag--info">
            {skills.map((skill) => {
              const skillOption = withLinks && skillsFilterOptions
                ? skillsFilterOptions.find(option => option.label === skill)
                : null
              const skillSlug = skillOption?.slug

              return (
                <Fragment key={skill}>
                  {withLinks && skillSlug ? (
                    <a href={`/3d-modeling-jobs/browse/${skillSlug}`} target="_blank">
                      <span key={`job-label-${skill}`} className="label label--info">{skill}</span>
                    </a>
                  ) : (
                    <span key={`job-label-${skill}`} className="label label--info">{skill}</span>
                  )}
                </Fragment>
              )
            })}
          </li>
        )}
      </ul>
      <SoftwareListContainer
        data={software}
        softwareFilterOptions={softwareFilterOptions}
        withLinks={withLinks}
      />
    </Fragment>
  )
}

JobInfoRow.propTypes = {
  type: PropTypes.string.isRequired,
  deadline: PropTypes.number,
  applicationCount: PropTypes.number,
  isResellable: PropTypes.bool.isRequired,
  isFeatured: PropTypes.bool,
  software: PropTypes.array.isRequired,
  status: PropTypes.string.isRequired,
  isApplicationCountVisible: PropTypes.bool.isRequired,
  tab: PropTypes.string,
  isViewerDesigner: PropTypes.bool,
  skills: PropTypes.array,
  skillsFilterOptions: PropTypes.array,
  softwareFilterOptions: PropTypes.array,
  withLinks: PropTypes.bool,
}

export default JobInfoRow
